// @ts-nocheck

/* eslint-disable sonarjs/max-switch-cases, sonarjs/no-duplicate-string */
import { __ } from '../i18n/l10n';
import { SportIds } from '../types/sports';
import NumberUtils from '../utils/number';
import UserUtils from '../utils/user';

import { getUserhasConnected } from './userStorage';

const matchStatusSimilarToPause = [
  'ended',
  'after_ot',
  'awaiting_ot',
  'awaiting_pen',
  'pen',
  'walkover',
  'retired',
  'delayed',
  'ot_ht',
  'interrupted',
  'abandoned',
  'postponed',
];

const getLabelForCommonSportStatus = (status) => {
  const sportKey = `sport-common.${status.toLowerCase()}`;

  switch (sportKey) {
    case 'sport-common.not_started':
      return '';
    case 'sport-common.1q':
      return __('1st quarter');
    case 'sport-common.2q':
      return __('2nd quarter');
    case 'sport-common.3q':
      return __('3rd quarter');
    case 'sport-common.4q':
      return __('4th quarter');
    case 'sport-common.1p':
      return __('1st period');
    case 'sport-common.2p':
      return __('2nd period');
    case 'sport-common.3p':
      return __('3rd period');
    case 'sport-common.1set':
      return __('1st set');
    case 'sport-common.2set':
      return __('2nd set');
    case 'sport-common.3set':
      return __('3rd set');
    case 'sport-common.4set':
      return __('4th set');
    case 'sport-common.5set':
      return __('5th set');
    case 'sport-common.6set':
      return __('6th set');
    case 'sport-common.7set':
      return __('7th set');
    case 'sport-common.8set':
      return __('8th set');
    case 'sport-common.9set':
      return __('9th set');
    case 'sport-common.10set':
      return __('10th set');
    case 'sport-common.gset':
      return __('golden set');
    case 'sport-common.delayed':
      return __('delayed');
    case 'sport-common.walkover':
      return __('retired');
    case 'sport-common.retired':
      return __('retired');
    case 'sport-common.paused':
      return __('pause');
    case 'sport-common.pause1':
      return __('pause');
    case 'sport-common.pause2':
      return __('pause');
    case 'sport-common.pause3':
      return __('pause');
    case 'sport-common.pause4':
      return __('pause');
    case 'sport-common.ended':
      return __('match finished');
    case 'sport-common.awaiting_ot':
      return '';
    case 'sport-common.ot':
      return __('overtime');
    case 'sport-common.1p_ot':
      return __('overtime');
    case 'sport-common.ot_ht':
      return __('overtime');
    case 'sport-common.2p_ot':
      return __('overtime');
    case 'sport-common.after_ot':
      return __('overtime finished');
    case 'sport-common.awaiting_pen':
      return '';
    case 'sport-common.pen':
      return __('penalty shoot-out');
    case 'sport-common.interrupted':
      return __('match interrupted');
    case 'sport-common.SD':
      return __('sudden death');
    case 'sport-common.postponed':
      return __('match postponed');
    case 'sport-common.in_progress':
      return __('match in progress');
    case 'sport-common.abandoned':
      return __('abandoned');
    case 'sport-common.started':
      return __('match started');
    default:
      return ' ';
  }
};
const getLabelForSportIdStatus = (sportId, status) => {
  if (status && status.toLowerCase) {
    const sportKey = `sport-${sportId}.${status.toLowerCase()}`;

    switch (sportKey) {
      case 'sport-1.not_started':
        return '';
      case 'sport-1.1p':
        return __('1st half');
      case 'sport-1.paused':
        return __('half-time');
      case 'sport-1.2p':
        return __('2nd half');
      case 'sport-1.ended':
        return __('match finished');
      case 'sport-1.awaiting_ot':
        return __('extra-time will begin');
      case 'sport-1.ot':
        return '';
      case 'sport-1.1p_ot':
        return __('extra-time - 1st half');
      case 'sport-1.ot_ht':
        return __('extra-time half-time');
      case 'sport-1.2p_ot':
        return __('extra-time - 2nd half');
      case 'sport-1.after_ot':
        return __('extra-time finished');
      case 'sport-1.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-1.pen':
        return __('penalty shoot-out');
      case 'sport-1.interrupted':
        return __('match interuppted');
      case 'sport-2.not_started':
        return '';
      case 'sport-2.1q':
        return __('1st quarter');
      case 'sport-2.pause1':
        return __('the 2nd quarter will begin');
      case 'sport-2.2q':
        return __('2nd quarter');
      case 'sport-2.pause2':
        return __('half-time');
      case 'sport-2.3q':
        return __('3rd quarter');
      case 'sport-2.pause3':
        return __('the 4th quarter will begin');
      case 'sport-2.4q':
        return __('4th quarter');
      case 'sport-2.ended':
        return __('match finished');
      case 'sport-2.ot':
        return __('overtime');
      case 'sport-2.interrupted':
        return __('match interuppted');
      case 'sport-2.awaiting_ot':
        return __('overtime will begin');
      case 'sport-2.after_ot':
        return __('overtime finished');
      case 'sport-3.not_started':
        return '';
      case 'sport-3.1it':
        return __('1st innings');
      case 'sport-3.bt1b1':
        return __('pause');
      case 'sport-3.1ib':
        return __('1st innings');
      case 'sport-3.bt2b1':
        return __('pause');
      case 'sport-3.2it':
        return __('2nd innings');
      case 'sport-3.bt2b2':
        return __('pause');
      case 'sport-3.2ib':
        return __('2nd innings');
      case 'sport-3.bt3b2':
        return __('pause');
      case 'sport-3.3it':
        return __('3rd innings');
      case 'sport-3.bt3b3':
        return __('pause');
      case 'sport-3.3ib':
        return __('3rd innings');
      case 'sport-3.bt4b3':
        return __('pause');
      case 'sport-3.4it':
        return __('4th innings');
      case 'sport-3.bt4b4':
        return __('pause');
      case 'sport-3.4ib':
        return __('4th innings');
      case 'sport-3.bt5b4':
        return __('pause');
      case 'sport-3.5it':
        return __('5th innings');
      case 'sport-3.bt5b5':
        return __('pause');
      case 'sport-3.5ib':
        return __('5th innings');
      case 'sport-3.bt6b5':
        return __('pause');
      case 'sport-3.6it':
        return __('6th innings');
      case 'sport-3.bt6b6':
        return __('pause');
      case 'sport-3.6ib':
        return __('6th innings');
      case 'sport-3.bt7b6':
        return __('pause');
      case 'sport-3.7it':
        return __('7th innings');
      case 'sport-3.bt7b7':
        return __('pause');
      case 'sport-3.7ib':
        return __('7th innings');
      case 'sport-3.bt8b7':
        return __('pause');
      case 'sport-3.8it':
        return __('8th innings');
      case 'sport-3.bt8b8':
        return __('pause');
      case 'sport-3.8ib':
        return __('8th innings');
      case 'sport-3.bt9b8':
        return __('pause');
      case 'sport-3.9it':
        return __('9th innings');
      case 'sport-3.bt9b9':
        return __('pause');
      case 'sport-3.9ib':
        return __('9th innings');
      case 'sport-3.bteib9':
        return __('pause');
      case 'sport-3.eit':
        return __('extra innings');
      case 'sport-3.bteibei':
        return __('pause');
      case 'sport-3.eib':
        return __('extra innings');
      case 'sport-4.not_started':
        return '';
      case 'sport-4.1p':
        return __('1st period');
      case 'sport-4.2p':
        return __('2nd period');
      case 'sport-4.3p':
        return __('3rd period');
      case 'sport-4.paused':
        return __('pause');
      case 'sport-4.pause1':
        return __('the 2nd quarter will begin');
      case 'sport-4.pause2':
        return __('the 3rd quarter will begin');
      case 'sport-4.ot':
        return __('overtime');
      case 'sport-4.pen':
        return __('penalty shoot-out');
      case 'sport-4.ended':
        return __('match finished');
      case 'sport-4.interrupted':
        return __('match interrupted');
      case 'sport-4.awaiting_ot':
        return __('overtime will begin');
      case 'sport-4.after_ot':
        return __('overtime finished');
      case 'sport-4.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-5.not_started':
        return '';
      case 'sport-5.1set':
        return __('1st set');
      case 'sport-5.2set':
        return __('2nd set');
      case 'sport-5.3set':
        return __('3rd set');
      case 'sport-5.4set':
        return __('4th set');
      case 'sport-5.5set':
        return __('5th set');
      case 'sport-5.ended':
        return __('match finished');
      case 'sport-5.walkover':
        return __('walkover');
      case 'sport-5.retired':
        return __('retired');
      case 'sport-5.delayed':
        return __('match delayed');
      case 'sport-5.interrupted':
        return __('match interrupted');
      case 'sport-6.not_started':
        return '';
      case 'sport-6.1p':
        return __('1st half');
      case 'sport-6.paused':
        return __('half-time');
      case 'sport-6.2p':
        return __('2nd half');
      case 'sport-6.ended':
        return __('match finished');
      case 'sport-6.awaiting_ot':
        return __('extra-time will begin');
      case 'sport-6.ot':
        return __('extra-time');
      case 'sport-6.1p_ot':
        return __('extra-time - 1st half');
      case 'sport-6.ot_ht':
        return __('extra-time half-time');
      case 'sport-6.2p_ot':
        return __('extra-time - 2nd half');
      case 'sport-6.after_ot':
        return __('extra-time finished');
      case 'sport-6.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-6.pen':
        return __('penalty shoot-out');
      case 'sport-6.interrupted':
        return __('match interrupted');
      case 'sport-12.not_started':
        return '';
      case 'sport-12.1p':
        return __('1st half');
      case 'sport-12.paused':
        return __('half-time');
      case 'sport-12.2p':
        return __('2nd half');
      case 'sport-12.ended':
        return __('match finished');
      case 'sport-12.awaiting_ot':
        return __('extra-time will begin');
      case 'sport-12.ot':
        return '';
      case 'sport-12.1p_ot':
        return __('extra-time - 1st half');
      case 'sport-12.ot_ht':
        return __('extra-time half-time');
      case 'sport-12.2p_ot':
        return __('extra-time - 2nd half');
      case 'sport-12.after_ot':
        return __('extra-time finished');
      case 'sport-12.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-12.pen':
        return __('penalty shoot-out');
      case 'sport-12.SD':
        return __('sudden death');
      case 'sport-12.interrupted':
        return __('match interrupted');
      case 'sport-12.postponed':
        return __('match postponed');
      case 'sport-112.not_started':
        return '';
      case 'sport-112.1p':
        return __('1st period');
      case 'sport-112.paused':
        return __('half-time');
      case 'sport-112.2p':
        return __('2nd half');
      case 'sport-112.ended':
        return __('match finished');
      case 'sport-112.awaiting_ot':
        return __('extra-time will begin');
      case 'sport-112.ot':
        return '';
      case 'sport-112.1p_ot':
        return __('extra-time - 1st half');
      case 'sport-112.ot_ht':
        return __('extra-time half-time');
      case 'sport-112.2p_ot':
        return __('extra-time - 2nd half');
      case 'sport-112.after_ot':
        return __('extra-time finished');
      case 'sport-112.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-112.pen':
        return __('penalty shoot-out');
      case 'sport-112.SD':
        return __('sudden death');
      case 'sport-112.interrupted':
        return __('match interrupted');
      case 'sport-112.postponed':
        return __('match postponed');
      case 'sport-212.not_started':
        return '';
      case 'sport-212.1p':
        return __('1st period');
      case 'sport-212.paused':
        return __('half-time');
      case 'sport-212.2p':
        return __('2nd half');
      case 'sport-212.ended':
        return __('match finished');
      case 'sport-212.awaiting_ot':
        return __('extra-time will begin');
      case 'sport-212.ot':
        return '';
      case 'sport-212.1p_ot':
        return __('extra-time - 1st half');
      case 'sport-212.ot_ht':
        return __('extra-time half-time');
      case 'sport-212.2p_ot':
        return __('extra-time - 2nd half');
      case 'sport-212.after_ot':
        return __('extra-time finished');
      case 'sport-212.awaiting_pen':
        return __('penalty shoot-out');
      case 'sport-212.pen':
        return __('penalty shoot-out');
      case 'sport-212.SD':
        return __('sudden death');
      case 'sport-212.interrupted':
        return __('match interrupted');
      case 'sport-212.postponed':
        return __('match postponed');
      case 'sport-16.not_started':
        return '';
      case 'sport-16.1q':
        return __('1st quarter');
      case 'sport-16.pause1':
        return __('the 2nd quarter will begin');
      case 'sport-16.2q':
        return __('2nd quarter');
      case 'sport-16.pause2':
        return __('half-time');
      case 'sport-16.3q':
        return __('3rd quarter');
      case 'sport-16.pause3':
        return __('the 4th quarter will begin');
      case 'sport-16.4q':
        return __('4th quarter');
      case 'sport-16.ended':
        return __('match finished');
      case 'sport-16.ot':
        return __('overtime');
      case 'sport-16.interrupted':
        return __('match interrupted');
      case 'sport-16.awaiting_ot':
        return __('overtime will begin');
      case 'sport-16.after_ot':
        return __('overtime finished');
      case 'sport-19.not_started':
        return '';
      case 'sport-19.in_progress':
        return __('in progress');
      case 'sport-19.paused':
        return __('break');
      case 'sport-19.session_break':
        return __('session break');
      case 'sport-19.ended':
        return __('match finished');
      case 'sport-19.delayed':
        return __('match delayed');
      case 'sport-19.interrupted':
        return __('match interrupted');
      case 'sport-19.abandoned':
        return __('match abandoned');
      case 'sport-19.walkover':
        return __('walkover');
      case 'sport-19.retired':
        return __('retired');
      case 'sport-23.not_started':
        return '';
      case 'sport-23.1set':
        return __('1st set');
      case 'sport-23.pause1':
        return __('the 2nd set will begin');
      case 'sport-23.2set':
        return __('2nd set');
      case 'sport-23.pause2':
        return __('the 3rd set will begin');
      case 'sport-23.3set':
        return __('3rd set');
      case 'sport-23.pause3':
        return __('the 4th set will begin');
      case 'sport-23.4set':
        return __('4th set');
      case 'sport-23.pause4':
        return __('the 5th set will begin');
      case 'sport-23.5set':
        return __('5th set');
      case 'sport-23.ended':
        return __('match finished');
      case 'sport-23.walkover':
        return __('retired');
      case 'sport-23.retired':
        return __('abandoned');
      case 'sport-23.delayed':
        return __('match delayed');
      case 'sport-23.interrupted':
        return __('match interrupted');
      case 'sport-23.gset':
        return __('golden set');
      case 'sport-31.not_started':
        return '';
      case 'sport-31.1set':
        return __('1st set');
      case 'sport-31.pause1':
        return __('the 2nd set will begin');
      case 'sport-31.2set':
        return __('2nd set');
      case 'sport-31.pause2':
        return __('the 3rd set will begin');
      case 'sport-31.3set':
        return __('3rd set');
      case 'sport-31.ended':
        return __('match finished');
      case 'sport-31.walkover':
        return __('retired');
      case 'sport-31.retired':
        return __('abandoned');
      case 'sport-31.delayed':
        return __('match delayed');
      case 'sport-31.interrupted':
        return __('match interrupted');
      case 'sport-34.not_started':
        return '';
      case 'sport-34.1set':
        return __('1st set');
      case 'sport-34.pause1':
        return __('the 2nd set will begin');
      case 'sport-34.2set':
        return __('2nd set');
      case 'sport-34.pause2':
        return __('the 3rd set will begin');
      case 'sport-34.3set':
        return __('3rd set');
      case 'sport-34.ended':
        return __('match finished');
      case 'sport-34.walkover':
        return __('retired');
      case 'sport-34.retired':
        return __('abandoned');
      case 'sport-34.delayed':
        return __('match delayed');
      case 'sport-34.interrupted':
        return __('match interrupted');
      case 'sport-34.gset':
        return __('golden set');
      default:
        return getLabelForCommonSportStatus(status);
    }
  }
  return null;
};

const statusMatchBySport = (sportId, status) => {
  return getLabelForSportIdStatus(sportId, status);
};

// NOTE: finalSetScore like this : ['1:1', '2:2', '3:3', ...]
// additionne les scores de chacune des parties du temps réglementaires
const computeScore = (finalScore, server, limit = 2) =>
  finalScore.reduce((total, current, index) => {
    if (index < limit) {
      return total + NumberUtils.castNumber(current.split(':')[server]);
    }
    return total;
  }, 0);

const convertMatchTimeToSecond = (time) => {
  const matches = time.match(/([0-9]{1,}(?:([0-9]{2}))?)/g);
  let seconds = 0;
  if (matches.length > 0) {
    if (matches[0] !== undefined) {
      seconds = NumberUtils.castNumber(matches[0]) * 60;
    }
    if (matches[1] !== undefined) {
      seconds += NumberUtils.castNumber(matches[1]);
    }
  }
  return seconds;
};

const isPrivateScore = (sportId, privateScore) => {
  if (sportId === SportIds.TENNIS && privateScore === true) {
    return !UserUtils.isConnectedAtLeastOneTime() && !getUserhasConnected();
  }
  return false;
};

const isMatchStartWithin48OrEndDate = (matchStart: number | undefined, operationEndDate: number): boolean => {
  const nowInSec = Date.now() / 1000;
  const twoDaysInSec = 60 * 60 * 24 * 2;

  return typeof matchStart === 'number' && matchStart < operationEndDate / 1000 && matchStart - nowInSec < twoDaysInSec;
};

const MatchUtils = {
  isPrivateScore,
  computeScore,
  convertMatchTimeToSecond,
  statusMatchBySport,
  matchStatusSimilarToPause,
  isMatchStartWithin48OrEndDate,
};

export default MatchUtils;
